import React, { useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import { Button } from "reactstrap";
import $ from "jquery";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
import { estilosProvNew } from "./configProvinciasNew";

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  return isDesktop ? children : null;
};

const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  return isTablet ? children : null;
};

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const DarBaja = (props) => {
  const [habilitado, setHabilitado] = useState(true);
  const [motivo, setMotivo] = useState(null);
  const [cargando, setCargando] = useState(false);

  const history = useHistory();
  const colorProv =
    estilosProvNew[process.env.REACT_APP_COD_ORGANIZACION].primary;

  useEffect(() => {
    if (props.estadoPlataforma.userToken) {
      initDarBaja();
    } else if (!sessionStorage.getItem("Usuario")) {
      history.push("/");
    }
  }, [props.estadoPlataforma.userToken]);

  const initDarBaja = () => {
    const url =
      process.env.REACT_APP_URL_BASE_BACKEND +
      process.env.REACT_APP_WS_OPCION_DAR_BAJA;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + props.estadoPlataforma.userToken,
      },
    })
      .then((resp) => resp.json())
      .then((json) => {
        if (json.status === "ok") {
          setHabilitado(json.habilitado);
          setMotivo(json.motivo || null);
        } else if (json.status === "error") {
          props.mensajeErrorWS("Autoeliminación", json.errores);
        }
      })
      .catch(() => {
        props.mensajeErrorGeneral();
        sessionStorage.removeItem("Usuario");
        sessionStorage.removeItem("login");
      });
  };

  const confirmarDarBaja = () => {
    setCargando(true);
    let cerrarSesion = false;
    const url =
      process.env.REACT_APP_URL_BASE_BACKEND +
      process.env.REACT_APP_WS_CONFIRMAR_DAR_BAJA;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + props.estadoPlataforma.userToken,
      },
    })
      .then((resp) => {
        if (resp.status == process.env.REACT_APP_CODIGO_CERRO_SESION) {
          cerrarSesion = true;
        }
        return resp.json();
      })
      .then((json) => {
        setCargando(false);
        if (json.status === "ok") {
          props.cerrarSesion();
          history.push("/");
        } else if (json.status === "error") {
          props.mensajeErrorWS("Autoeliminación", json.errores, cerrarSesion);
        }
      })
      .catch(() => {
        setCargando(false);
        props.mensajeErrorGeneral();
        sessionStorage.removeItem("Usuario");
        sessionStorage.removeItem("login");
      });
  };

  const clickBtnDarBaja = () => {
    $.confirm({
      title: `<b class="op-text">Confirmar Autoeliminación</b>`,
      backgroundDismiss: true,
      columnClass: "medium",
      animation: "zoom",
      closeIcon: true,
      closeAnimation: "scale",
      content: `<h5 class="text-center mt-4 mb-2">
        Su cuenta quedará inhabilitada. Para habilitarte nuevamente, dirígete a la Lotería.
      </h5>`,
      buttons: {
        No: {
          text: "Cancelar",
          action: function () {},
        },
        Si: {
          text: "Aceptar",
          action: function () {
            confirmarDarBaja();
          },
        },
      },
    });
  };

  const panel = (
    <div
      className="bg-light p-2 w-90 mx-auto rounded shadow mb-5 darBajaPanel"
      style={{ marginTop: "6rem" }}
    >
      <div
        className={
          "text-light rounded text-center p-2 mb-3 bg-prov-" +
          process.env.REACT_APP_COD_ORGANIZACION
        }
      >
        <h4 className="m-0">Autoeliminación</h4>
      </div>

      <div className="text-center p-3">
        {"¿Está seguro que desea darse de baja? Esta acción inhabilitará su cuenta."}
        <p>{props.mensajeDarBaja || ""}</p>
      </div>

      {motivo && (
        <div className="alert alert-warning text-center mx-3">{motivo}</div>
      )}

      <div className="row text-center mt-3 mb-3">
        <div className="col">
          <Button
            onClick={clickBtnDarBaja}
            className="btn-info"
            disabled={!habilitado}
          >
            Autoeliminarse
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <Animated animationIn="fadeIn">
      <Mobile>{panel}</Mobile>
      <Tablet>{panel}</Tablet>
      <Desktop>{panel}</Desktop>
    </Animated>
  );
};

export default DarBaja;
